import { AspectRatio } from '@livecontrol/core-ui';
import _ from 'lodash';
import React from 'react';
import type { ScheduledEvent } from '../../graphql';

export const Preview = ({
  scheduledEvent
}: {
  scheduledEvent: ScheduledEvent | undefined;
}): React.ReactElement => {
  if (!scheduledEvent) {
    return <div className='text-white'>Could not load event details</div>;
  }

  return (
    <AspectRatio
      ratio={3 / 2}
      style={{
        borderRadius: 4,
        backgroundSize: 'cover',
        backgroundImage: `url('${
          scheduledEvent.background_url ??
          scheduledEvent.webplayer_placeholder_image ??
          '/assets/fallback-background.jpeg'
        }')`,
        boxShadow: 'inset 0px 50px 20px -20px var(--black60)'
      }}
    />
  );
};
